import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  containerSlider: {
    width: "200px",
    marginLeft: "15px",
    marginRight: "30px",
  },
}));

export default useStyles;
